export default "__VITE_ASSET__DDkopstv__"